import RecipeLogStep, { type RecipeLogStepProps } from '../RecipeLogStep'

const StoredStep = (props: Omit<RecipeLogStepProps, 'title' | 'description' | 'hint' | 'quantityKey' | 'logType' | 'showReason'>) => (
  <RecipeLogStep
    {...props}
    title="What's going into the fridge tonight?"
    description="Log the quantity of each recipe being stored in cold storage at the end of service."
    hint="Storing closes today's balance. Log this the same night food goes in the fridge."
    quantityKey="stored_quantity"
    logType="stored"
  />
)

export default StoredStep
